import CarsService from '../shared/services/carsService'
import { setLogout } from './authActions'

const RESPONSE_CAR_SHORT_INFO = 'RESPONSE_CAR_SHORT_INFO'
const REQUEST_CAR_SHORT_INFO_FAILURE = 'REQUEST_CAR_SHORT_INFO_FAILURE'

const responseGetCarShortInfoAction = (data) => {
  return {
    type: RESPONSE_CAR_SHORT_INFO,
    data,
  }
}

const requestGetCarShortInfofailureAction = (errors) => {
  return {
    type: REQUEST_CAR_SHORT_INFO_FAILURE,
    errors,
  }
}

const getCarShortInfo = (id) => {
  return (dispatch) => {
    CarsService.getCarShortInfo(id)
      .then((result) => {
        dispatch(responseGetCarShortInfoAction(Object.assign(result.data, { carId: id })))
      })
      .catch((error) => {
        dispatch(requestGetCarShortInfofailureAction(error.response))

        if (error.response && error.response.status === 401) {
          dispatch(setLogout())
        }
      })
  }
}

export {
  getCarShortInfo,
  responseGetCarShortInfoAction,
  requestGetCarShortInfofailureAction,
  RESPONSE_CAR_SHORT_INFO,
  REQUEST_CAR_SHORT_INFO_FAILURE,
}
